module.exports = __webpack_public_path__ + "static/media/b24c78e0.jpg";